import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';

import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { GreetingResponse } from './models/greeting-response.model';
import { GreetingModel } from './models/greeting.model';

@Injectable({
  providedIn: 'root',
})
export class GreetingService extends BaseGQLService<GreetingResponse> {
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: GreetingModel,
        clientName: 'GreetingService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: ' queryGreetingPopupContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState,
    );
  }


}


